import { render, staticRenderFns } from "./UnomiConfig.vue?vue&type=template&id=514e0a74&scoped=true"
import script from "./UnomiConfig.vue?vue&type=script&lang=js"
export * from "./UnomiConfig.vue?vue&type=script&lang=js"
import style0 from "./UnomiConfig.vue?vue&type=style&index=0&id=514e0a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e0a74",
  null
  
)

export default component.exports